module.exports = __webpack_public_path__ + "img/11.754b86b1.png";